import { render } from "./WolfcampusView.vue?vue&type=template&id=f8a6933e&scoped=true"
import script from "./WolfcampusView.vue?vue&type=script&lang=js"
export * from "./WolfcampusView.vue?vue&type=script&lang=js"

import "./WolfcampusView.vue?vue&type=style&index=0&id=f8a6933e&scoped=true&lang=css"

import exportComponent from "/home/dre/personalsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8a6933e"]])

export default __exports__